import { Box, TextField, Typography } from '@mui/material'
/**
 * The SerialNumberFilter component
 * @component
 *
 * @param {Object} props
 * @param {function} props.handleChangeNumSerie
 * @returns {JSX.Element}
 */

const OrderNumberFilter = ({ orderNumber, handleOrderNumber }) => {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      {' '}
      <Typography variant="body1">Número</Typography>
      <TextField
        sx={{ mb: 1, width: '49.5%', minWidth: '49.5%' }}
        variant="standard"
        inputProps={{ max: 9999999999 }}
        value={orderNumber}
        onChange={(e) => {
          const value = e.target.value.slice(0, 10)
          handleOrderNumber(value)
        }}
        type={'number'}
        placeholder={'Número'}
        fullWidth
      />
    </Box>
  )
}

export default OrderNumberFilter
